import s from "./_baseHasIn.js";
import n from "./_hasPath.js";
var t = s, h = n;
function o(a, r) {
  return a != null && h(a, r, t);
}
var m = o;
export {
  m as default
};
//# sourceMappingURL=hasIn.js.map
